import React from 'react';
import { Link } from 'react-router-dom';
import { DocumentTextIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          <div className="flex items-center gap-3">
            <DocumentTextIcon className="w-8 h-8 text-green-600" />
            <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          </div>
          <p className="text-gray-600 mt-2">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-8 prose prose-lg max-w-none">
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Acceptance of Terms</h2>
            <p className="text-gray-700">
              By using Group Chat Heroes, you agree to these Terms of Service. If you don't agree, 
              please don't use our platform.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">What You Can Do</h2>
            <ul className="space-y-2 text-gray-700">
              <li>• Create and share games</li>
              <li>• Play games created by others</li>
              <li>• Join leaderboards and compete</li>
              <li>• Share games with friends</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">What You Can't Do</h2>
            <ul className="space-y-2 text-gray-700">
              <li>• Create inappropriate, offensive, or harmful content</li>
              <li>• Spam or abuse the platform</li>
              <li>• Try to hack or break our systems</li>
              <li>• Impersonate others or create fake accounts</li>
              <li>• Use the platform for commercial purposes without permission</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Your Content</h2>
            <p className="text-gray-700 mb-4">
              When you create games or content on Group Chat Heroes:
            </p>
            <ul className="space-y-2 text-gray-700">
              <li>• You own your content</li>
              <li>• You give us permission to host and share it</li>
              <li>• You're responsible for what you create</li>
              <li>• We can remove content that violates these terms</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Service Availability</h2>
            <p className="text-gray-700">
              We try to keep Group Chat Heroes running smoothly, but we can't guarantee 100% uptime. 
              We may need to temporarily suspend service for maintenance or updates.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Limitation of Liability</h2>
            <p className="text-gray-700">
              Group Chat Heroes is provided "as is." We're not responsible for any damages or losses 
              from using our platform. Use at your own risk.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Privacy</h2>
            <p className="text-gray-700">
              Your privacy is important to us. Please review our{' '}
              <Link to="/privacy" className="text-blue-600 hover:underline">
                Privacy Policy
              </Link>{' '}
              to understand how we handle your data.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Account Termination</h2>
            <p className="text-gray-700">
              We may suspend or terminate accounts that violate these terms. You can also 
              delete your account at any time.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Changes to Terms</h2>
            <p className="text-gray-700">
              We may update these terms occasionally. We'll notify users of significant changes 
              and post the new version here.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact Us</h2>
            <p className="text-gray-700">
              Questions about these terms? Contact us at{' '}
              <a href="mailto:support@groupchatheroes.com" className="text-blue-600 hover:underline">
                support@groupchatheroes.com
              </a>
            </p>
          </section>

          <div className="border-t pt-6 mt-8">
            <p className="text-sm text-gray-500">
              These terms are effective as of the date listed above and remain in effect 
              until changed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 